var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSundhedplusLogoInvert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 194,
    height: 40,
    viewBox: "0 0 194 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "qyjdh1obnc",
    x1: "62.552%",
    x2: "15.587%",
    y1: "27.953%",
    y2: "80.997%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#C76169"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#BE323C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "wukfwaot2d",
    x1: "99.248%",
    x2: "10.151%",
    y1: "89.119%",
    y2: "13.442%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#C76169"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#BE323C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "qaasm9f1ie",
    x1: "4.739%",
    x2: "99.248%",
    y1: "59.853%",
    y2: "33.996%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#C76169"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#BE323C"
  })), /*#__PURE__*/React.createElement("path", {
    id: "drtu06vvra",
    d: "M41.756 7.21c-2.749-1.093-5.884-.447-7.976 1.644l-1.047 1.05-1.397 1.395-1.398 1.397-3.827 3.842-1.397 1.395-1.41 1.4-1.39-1.4-1.398-1.395-3.847-3.842-1.395-1.397-1.397-1.395-1.047-1.05c-.714-.714-.775-1.85-.141-2.637.294-.37.724-.607 1.195-.657.704-.086 1.408.16 1.904.667l.881.882 1.398 1.397 1.397 1.398 3.84 3.84 3.842-3.84 1.397-1.398 1.395-1.397 1.05-1.047c1.912-1.908 4.444-3.069 7.138-3.272-.42-.512-.906-.967-1.445-1.353-2.962-2.121-7.056-1.681-9.63.896l-.94.936-1.397 1.395-1.398 1.398-1.402-1.398-1.398-1.395-.956-.95c-2.585-2.58-6.676-3.015-9.641-.887-.536.388-1.018.845-1.435 1.358-.477.581-.86 1.233-1.138 1.931-1.094 2.748-.447 5.884 1.644 7.975l1.047 1.047 1.395 1.393 1.398 1.397 3.84 3.845 1.397 1.397 1.397 1.398 3.84 3.84 3.842-3.84 1.397-1.398 1.395-1.397 3.842-3.84 1.398-1.402 1.395-1.398 1.05-1.047c.714-.713 1.851-.772 2.636-.138.238.188.424.432.541.711.32.812.119 1.737-.509 2.343l-.923.926-2.795 2.8-3.84 3.84-1.397 1.395-1.398 1.397-3.827 3.842-2.807 2.793-2.793-2.793-3.842-3.842-1.395-1.397-1.397-1.395-3.842-3.84-2.793-2.795-1.047-1.05c-1.917-1.907-3.086-4.44-3.294-7.137-.192.158-.378.326-.558.493C.951 10.235.17 12.124.172 14.091c.002 1.968.787 3.854 2.181 5.242l7.682 7.68 1.397 1.397 1.398 1.397 9.775 9.773c.185.186.437.291.7.291.263 0 .515-.105.7-.29l9.775-9.776 1.398-1.398 1.395-1.397 7.585-7.585c2.58-2.58 3.017-6.667.889-9.63-.386-.534-.839-1.016-1.348-1.435-.585-.48-1.24-.869-1.943-1.15z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "tqjeoz7dgb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#drtu06vvra"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    fillRule: "nonzero",
    xlinkHref: "#drtu06vvra"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    mask: "url(#tqjeoz7dgb)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "url(#qyjdh1obnc)",
    d: "M24.875 6.159l-4.08 19.668c13.949 1.712 20.924 2.63 20.924 2.754l-.505 12.286-29.056-4.699.576-28.378c0-2.727 4.047-3.271 12.141-1.631z",
    transform: "translate(-1.728 -13.58) rotate(-45 26.938 23.05)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#wukfwaot2d)",
    d: "M19.689 6.749l16.93 14.504-.54 5.824c0 .287-18.54-2.095-18.54-2.383l-3.766-12.04c0-3.272 2.653-5.925 5.926-5.925l-.01.02z",
    transform: "translate(-1.728 -13.58) rotate(-45 25.196 16.915)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#qaasm9f1ie)",
    d: "M49.677 29.71l-1.568-3.811c-2.313-2.304-6.053-2.304-8.366 0l-4.449 7.361-10.448 10.623c-.261-.837-7.082-8.544-20.463-23.12C2.07 18.459-.082 29.787.017 29.885l25.419 26.523C42.613 39.626 50.694 30.726 49.677 29.71z",
    transform: "translate(-1.728 -13.58)"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "#222120",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.867 9.222C6.484 8.198 5.958 7.514 5.958 6.521c0-.87.775-1.644 2.326-1.644 1.988 0 3.01.963 3.756 2.513l4.197-2.452C14.657 1.743 11.864.037 8.294.037c-3.753 0-7.292 2.42-7.292 6.607 0 4.188 3.166 5.712 6.393 6.61 3.227.9 4.499 1.427 4.499 2.763 0 .837-.59 1.768-2.948 1.768-2.452 0-3.786-1.21-4.56-3.01L.1 17.245c1.213 3.21 4.129 5.37 8.69 5.37 4.718 0 8.068-2.484 8.068-6.667-.01-4.585-3.703-5.733-6.992-6.726zM28.58 15.148c0 2.21-1.19 3.198-2.896 3.198-1.482 0-2.699-.9-2.699-2.823V6.677h-4.654v9.525c0 4.198 2.669 6.42 5.802 6.42 2.047 0 3.6-.74 4.445-1.894v1.46h4.654V6.677H28.58v8.471zM43.798 6.247c-2.047 0-3.6.74-4.445 1.894V6.677h-4.647v15.516h4.654V13.72c0-2.205 1.18-3.21 2.887-3.21 1.481 0 2.699.901 2.699 2.825v8.844H49.6v-9.513c0-4.198-2.667-6.42-5.802-6.42zM63.037 8.136c-1.025-1.18-2.546-1.89-4.625-1.89-4.064 0-7.407 3.569-7.407 8.194 0 4.624 3.35 8.192 7.407 8.192 2.08 0 3.6-.713 4.625-1.894v1.46h4.654V.469h-4.654v7.667zM59.333 18.22c-2.14 0-3.691-1.46-3.691-3.785 0-2.326 1.55-3.786 3.691-3.786s3.704 1.457 3.704 3.786c0 2.328-1.553 3.785-3.694 3.785h-.01zM78.264 6.247c-2.05 0-3.6.74-4.444 1.894V.486h-4.647v21.729h4.654V13.72c0-2.205 1.178-3.21 2.887-3.21 1.481 0 2.698.901 2.698 2.825v8.844h4.655v-9.513c0-4.198-2.67-6.42-5.803-6.42zM93.802 6.247c-4.903 0-8.254 3.568-8.254 8.193 0 4.624 3.289 8.192 8.595 8.192 2.948 0 5.245-1.086 6.766-3.21l-3.724-2.14c-.622.683-1.706 1.177-2.98 1.177-1.706 0-3.133-.558-3.724-2.17H101.5c.126-.613.188-1.237.185-1.862 0-4.679-3.35-8.18-7.882-8.18zM90.39 12.82c.432-1.583 1.612-2.452 3.38-2.452 1.398 0 2.793.652 3.29 2.452h-6.67zM115.205.472v7.654c-1.025-1.17-2.546-1.88-4.625-1.88-4.064 0-7.407 3.569-7.407 8.194 0 4.624 3.35 8.192 7.407 8.192 2.08 0 3.6-.713 4.625-1.894v1.46h4.654V.469l-4.654.003zM111.5 18.22c-2.14 0-3.703-1.46-3.703-3.785 0-2.326 1.55-3.786 3.703-3.786 2.153 0 3.704 1.457 3.704 3.786 0 2.328-1.55 3.785-3.694 3.785h-.01zM137.748 5.22L132.998 5.22 132.998.472 129.546.472 129.546 5.22 124.798 5.22 124.798 8.674 129.546 8.674 129.546 13.422 132.998 13.422 132.998 8.674 137.748 8.674z",
    transform: "translate(55.556 9.136)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSundhedplusLogoInvert);
export default __webpack_public_path__ + "static/media/sundhedplus-logo-invert.d1fe16cd5e260ff88f0d35730d8a27cf.svg";
export { ForwardRef as ReactComponent };